/**
 * Pages anyone can open without signing in, rendered before the sign-in
 * (MSAL) setup starts, so a visitor with no account never meets a login
 * redirect (as skySchedule's lib/publicPages.ts). Keep this list short and
 * static: a page here is world-readable.
 */
const PUBLIC_PATHS = new Set(["/sms"]);

/** True for a public page path; a trailing slash, query string and case are ignored. */
export function isPublicPath(pathname: string): boolean {
  const path = pathname.split("?")[0].replace(/\/+$/, "").toLowerCase();
  return PUBLIC_PATHS.has(path);
}
